import React from "react"
import { ArticlesFilteredsTypes } from "../../../models/news-articles/articles-filtered-model"
import Newsarticle from "./news-article"

type PropsType = {
  articles: ArticlesFilteredsTypes[]
}

const NewsArticleTop = (props: PropsType) => {

  const ArticlesFilteredsData = props.articles;
  return <div className="post-list post-list-data row">
    {ArticlesFilteredsData[0]?.articlesList?.map((item, index) => {
        return <React.Fragment key={index}>
          {(index < 4) ? (
              <div className="col-md-6" key={index}>
                <Newsarticle article={item} />
              </div>
            ) : null}
        </React.Fragment>
      })}
  </div>
}

export default NewsArticleTop;
